module.exports = __webpack_public_path__ + "static/media/ms624_logo.4b111aa4.png";